import React from 'react';
import cx from 'classnames';
import FeedPicture from './FeedPicture.jsx';
import FeedText from './FeedText.jsx';
import ContentMeta from '../ContentMeta.jsx';
import ArticleLink from '../ArticleLink.jsx';
import Thumbnail from '../Thumbnail.jsx';

export default class FeedContainerSimpleBox extends React.PureComponent {
  render() {
    const { contentContainer, keepSideBySide, titlePrefix, hideTags, useVideoTypeTags, smallRibbon } = this.props;
    if (!contentContainer) return null;

    return (
      <div className={cx('feed-container feed-container-simple container-fluid', { 'feed-container-side-by-side': keepSideBySide })}>

        <div className="row">
          <div className={cx('col-xs-4', { 'col-md-12': !keepSideBySide })}>
            <ArticleLink contentContainer={contentContainer}>
              <Thumbnail smallRibbon={smallRibbon} data={contentContainer} maxItems={1}>
                <FeedPicture contentContainer={contentContainer} size={2}/>
              </Thumbnail>
            </ArticleLink>
          </div>

          <div className={cx('col-xs-8 feed-content', { 'col-md-12': !keepSideBySide })}>
            <h4>
              <ArticleLink contentContainer={contentContainer}>
                <FeedText titlePrefix={titlePrefix} contentContainer={contentContainer} />
              </ArticleLink>
            </h4>
            <ContentMeta hideTags={hideTags} useVideoTypeTags={useVideoTypeTags} data={contentContainer} noTimestamp />
          </div>
        </div>
      </div>
    );
  }
}

FeedContainerSimpleBox.propTypes = {
  contentContainer: React.PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerSimpleBox.jsx